/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/loader/silly/silly_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ LOADER : SILLY : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const SillyLoader = () => {
	return (
		<div className={`loader ${sheet.classes.silly}`}>
			<div className='bar'/>
			<div className='bar'/>
			<div className='bar'/>
			<div className='bar'/>
			<div className='bar'/>
			<div className='bar'/>
		</div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default SillyLoader;
